import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposImoveis } from './tipos_imoveis_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposImoveisListar() {
    return _jsx(GridBase, { pagina: PAGINAS.TIPOS_IMOVEIS, paginaPermissao: FUNCIONALIDADES.TIPOS_IMOVEIS, rota: ROUTES.TIPOS_IMOVEIS, fetchData: function (str, _filter, pag) { return getTiposImoveis(str, pag); }, columns: COLUNAS });
}
export default TiposImoveisListar;
